<template>
  <div 
    class="matrix-select" 
    ref="matrixSelectRef"
    @scroll="onMatrixSelectScroll"
  >  
    <div 
      class="matrix-row"
      :style="{
        width: `${24 + (filterMatrixOption('matrix_col').length * 23)}%`
      }"
    >
      <div 
        class="matrix-title place"
      >
        <div v-if="showPlace" class="place-child" :style="`height: ${placeHeight}`"></div>
      </div>
      <div
        v-for="(matrixColItem, indexCol) in filterMatrixOption('matrix_col')"
        :key="indexCol"
        class="matrix-col"
      >
        {{ matrixColItem.name }}
      </div>
    </div>
    <div
      v-for="(matrixRowItem, indexRow) in filterMatrixOption('matrix_row')"
      :key="indexRow"
      class="matrix-row question"
      :style="{
        width: `${24 + (filterMatrixOption('matrix_col').length * 23)}%`
      }"
    >
      <div class="matrix-title">
        <div class="name-text">{{ matrixRowItem.name }}</div>
        <!-- <div v-if="indexRow === filterMatrixOption('matrix_row').length - 1" class="place-child"></div> -->
      </div>
      <div
        v-for="(matrixColItem, indexCol) in filterMatrixOption('matrix_col')"
        :key="indexCol"
        class="matrix-col"
      >
        <div 
          class="matrix-radio"
          :class="{
            'check': itemValue[matrixRowItem.id] === matrixColItem.id,
            'disabled': readonly
          }"
          @click="clickMatrixRadio(matrixRowItem, matrixColItem)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      showPlace: false,
      placeHeight: 'auto'
    };
  },
  computed: {
  },
  components: {
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      const tmpObj = {};
      if (this.submitValue?.value) {
        const rows = this.filterMatrixOption('matrix_row');
        const cols = this.filterMatrixOption('matrix_col');
        for(let key in this.submitValue.value) {
          let rowIndex = rows.findIndex(v => v.id === key);
          if (rowIndex >= 0) {
            tmpObj[key] = null;
            let colIndex = cols.findIndex(v => v.id === this.submitValue.value[key]);
            if (colIndex >= 0) {
              tmpObj[key] = this.submitValue.value[key];
            }
          }
        }
      }
      this.itemValue = tmpObj;
      this.$nextTick(() => {
        this.placeHeight = (this.$refs['matrixSelectRef'].offsetHeight + 100) + 'px';
      });
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    },
    filterMatrixOption(type) {
      return this.item.option.filter((v) => v.type === type);
    },
    clickMatrixRadio(matrixRowItem, matrixColItem) {
      if (this.readonly) {
        return;
      }
      if (this.itemValue[matrixRowItem.id] === matrixColItem.id) {
        this.itemValue[matrixRowItem.id] = null;
      } else {
        this.itemValue[matrixRowItem.id] = matrixColItem.id;
      }
      this.onValueChange();
    },
    onMatrixSelectScroll(e) {
      this.showPlace = !!e?.target?.scrollLeft;
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.matrix-select {
  // overflow: auto;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
}
.matrix-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
  // padding: 10px 6px 10px 10px;
  min-width: 100% !important;
  box-sizing: border-box;
  position: relative;
  // overflow: hidden;
  &.question {
    background-color: #F9F9F9;
  }
  .form-item-text-1();
  color: @desc-color-1;
  .matrix-title {
    flex: 1;
    width: 24%;
    // height: 36px;
    // line-height: 36px;
    
    position: sticky;
    left: 0px;
    z-index: 2;
    
    // box-shadow: 7px 0 5px -5px rgba(0, 0, 0, 0.05);
    // margin: -10px 0 0 -10px;
    .name-text {
      padding: 10px 6px;
      color: @desc-color-1;
      background-color: #F9F9F9;
      position: relative;
      z-index: 2;
    }
    &.place {
      // background-color: #fff;
      // box-shadow: none;
      // position: relative;
      // position: initial;
    }
    .place-child {
      box-shadow: 7px 0 5px -5px rgba(0, 0, 0, 0.05);
      background-color: #fff;
      position: absolute;
      width: 100%;
      height: auto;
      top: -100px;
      left: 0px;
      z-index: 1;
    }
  }
  .matrix-col {
    margin: 0 0 0 8px;
    padding: 10px 0;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    text-align: center;
    width: 70px;
  }
  .matrix-radio {
    background-color: #fff;
    .radio-icon();
  }
}
</style>
